import request from '@host-panel/request';
import { RequestPayload, Response } from './posts-read';
import { Sorting } from '../state/types';

export default function searchByText({
  spotId,
  contentType = 'COMMENTS',
  folder,
  count,
  sortBy = Sorting.NEWEST,
  offset = 0,
  lock = false,
  tag = 'all',
  advancedFilters = { text: '' }
}: RequestPayload): Promise<Response> {
  return request(`/host-panel/search/${contentType.toLowerCase()}/folder/${folder}`, {
    method: 'GET',
    data: {
      spot_id: spotId,
      sort_by: sortBy,
      count,
      offset,
      should_lock: lock,
      tag,
      ...advancedFilters
    }
  });
}
